import { render } from "./Baner.vue?vue&type=template&id=2c6cc759&scoped=true"
import script from "./Baner.vue?vue&type=script&lang=js"
export * from "./Baner.vue?vue&type=script&lang=js"

import "./Baner.vue?vue&type=style&index=0&id=2c6cc759&scoped=true&lang=css"

import exportComponent from "/mnt/7e868b86-35b8-4c8b-aa8f-81c8fe9154a3/work/Илюха/texuspex.ru/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6cc759"]])

export default __exports__